/*
Alarms controller
*/
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  connect(){
    // setInterval(this.call, 3000);
  }


  call(){
    let url = `${window.location.href}admin_tasks/alerts`
    fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest", contentType: "text/javascript" }, dataType: "script" })
  }
}